<template>
  <div class="page-container">
    <div id="searchArea">
      <div class="clearfix">
        <div class="fl pb10">
          <el-button type="primary" @click="addOrUpdateHandle()">Add Tag</el-button>
        </div>
        <div class="fr">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
            <el-form-item>
              <el-input v-model="dataForm.tagName" placeholder="Tag Name" clearable class="wd300"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div>
      <el-table
        max-height="680"
        v-loading="dataListLoading"
        :data="dataList"
        @sort-change="tableSortChange"
        :default-sort="{ prop: 'createTime', order: 'descending' }"
        style="width: 100%"
      >
        <el-table-column prop="tagName" align="center" label="Tag Name" min-width="150" sortable="custom"></el-table-column>
        <el-table-column prop="remark" align="center" label="Remark" min-width="200"></el-table-column>
        <el-table-column prop="createTime" align="center" label="Create Time" width="180" sortable="custom"></el-table-column>
        <el-table-column prop="updateTime" align="center" label="Update Time" width="180"></el-table-column>
        <el-table-column prop="createUserInfo" align="center" label="Creator" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createUserInfo.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Action" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="fwb" @click="addOrUpdateHandle(scope.row)">Edit</el-button>
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 新建或修改 = 弹窗 -->
    <add-or-update-dialog ref="addOrUpdateDialog" @update="getDataList" />
  </div>
</template>

<script>
import AddOrUpdateDialog from "./modal/AddOrUpdate";
import Pagination from "@/components/Pagination";
import paginationMixin from "@/mixins/paginationMixin";
import tableMixin from "@/mixins/tableMixin";
export default {
  mixins: [paginationMixin, tableMixin],
  components: {
    AddOrUpdateDialog,
    Pagination,
  },
  data() {
    return {
      dataForm: {
        tagName: "",
        "orders[0].asc": false,
        "orders[0].column": "id",
      },
      dataList: [],
      dataListLoading: false,
    };
  },
  methods: {
    // 获取数据分页
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/clientTagInfo/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 删除
    async deleteHandle(row) {
      await this.$confirm(`Delete this tag. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      });
      const { code, msg } = await this.$http.post(`/admin/clientTagInfo/${row.id}/delete`, {});
      if (code === 200) {
        this.$message({
          message: "success",
          type: "success",
          duration: 1500,
          onClose: () => {
            // mixins
            this.singleDataDelete();
            this.getDataList();
          },
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 新增 / 修改
    addOrUpdateHandle(row) {
      this.$refs.addOrUpdateDialog.init(row);
    },
  },
  activated() {
    // 获取分页数据
    this.getDataList();
  },
};
</script>

<style lang="scss" scoped></style>
